import React from 'react';
import $ from 'jquery';
import { Link } from 'react-router-dom';

import Header from './../../component/common/Header';
import ModalWindow from '../../component/common/ModalWindow';
import AddComment from './../../component/encashment/CommentWithStatus';
import Loader from './../../component/common/Loader';
import CONSTANT from './../../constant';
import Shimmer from '../../component/common/Shimmer';

import { getDetail, addComment } from '../../actions/EncashmentAction';
// import { getLeaveDetail, updateStatus, requestCancellation, manageCancellation } from '../../actions/LeaveAction';
import { getDateParts, getCookie, getStorage } from '../../utils';

class ComponentName extends React.Component<any, any>{
    constructor(props: any) {
        super(props);
        this.state = {
            code: props.match.params.code,
            ud: getCookie(CONSTANT.cookie.userDetail),

            permissions: getStorage(CONSTANT.cookie.permissions),
            detail: undefined,
            comments: undefined,

            showAddComment: false,
            showLoader: false
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        document.title = CONSTANT.pageTitle.leaveDetail;

        const { code } = this.state;
        getDetail(code).then((res: any) => {
            this.setState({ detail: res.result.detail, comments: res.result.comment });
        });
    }

    render() {
        const { code, detail, comments } = this.state;
        const { showAddComment, showLoader, ud } = this.state;
        const showAddCommentButton = detail && detail.assignedTo === ud.code;

        return (
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-2 px-0">
                        <Header />
                    </div>
                    <div className="col-md-10">
                        <div className="row my-3">
                            <div className="col-md-8">
                                <h1 className="page-title">Encashment detail</h1>
                            </div>
                            <div className="col-md-4">
                                <Link to={CONSTANT.component.userLeaveEncashmentList.url} className="btn btn-sm btn-link float-right">Go Back</Link>
                                <button onClick={this.onPrint} className="btn btn-sm btn-link float-right"><i className="fa fa-print" /> Print</button>
                            </div>
                        </div>
                        <div className="row">

                            <div className="col-md-12">
                                {
                                    detail === undefined && <Shimmer />
                                }
                                {
                                    detail !== undefined && this.renderDetail()
                                }
                                {
                                    comments !== undefined && this.renderComments()
                                }
                            </div>

                        </div>

                    </div>
                </div>
                {
                    showLoader && <Loader />
                }
                {
                    showAddComment && <ModalWindow
                        title="Manage Encashment"
                        backdrop="static"
                        toggleModal={this.toggleAddComment}
                    >
                        <AddComment
                            detailId={code}
                            onSubmit={this.onAddComment}
                            toggleModal={this.toggleAddComment}
                        />
                    </ModalWindow>
                }
                {
                    showAddCommentButton && <div className="comment-button bg-primary text-white btn btn-sm" onClick={this.toggleAddComment}>
                        Manage Encashment
                    </div>
                }
            </div>
        )
    }

    renderDetail = () => {
        const { detail } = this.state;
        const createdOn = getDateParts(detail.createdOn);
        // const startDate = getDateParts(detail.startDate);
        // const endDate = getDateParts(detail.endDate);
        // const leaveDuration = CONSTANT.static.leaveDuration.filter((i: any) => i.code === detail.duration);

        return (
            <div className="card main-file mb-3">
                <div className="card-body">
                    <div className="row">
                        <div className="col-md-12">
                            {/* Address: {detail.addressTypeName} {detail.remoteAddress ? ` (${detail.remoteAddress})` : ''}<br /> */}
                            {/* Leave type: {detail.leaveTypeId == CONSTANT.static.leaveType.el ? 'Earned Leave' : detail.leaveTypeName}<br /> */}
                            Number of days: {detail.numberOfDays}
                            {/* # Days: {(detail.leaveTypeId === CONSTANT.static.leaveType.cml || detail.leaveTypeId === CONSTANT.static.leaveType.hpl) && parseFloat(detail.noOfDays) === 1 ? `${leaveDuration[0].name}` : `${detail.noOfDays} Day(s)`} ({`${startDate.date} ${startDate.monthName} ${startDate.year} - ${endDate.date} ${endDate.monthName} ${endDate.year}`}) */}
                            <br />
                        </div>
                        <div className="col-md-12 mt-3 text-right">
                            <span className="fs-12">
                                {detail.createdByName}<br />
                                {detail.createdByDesignation}<br />
                                {`${createdOn.date} ${createdOn.monthName} ${createdOn.year} ${createdOn.hour}:${createdOn.minute}:${createdOn.seconds} ${createdOn.amOrpm}`}</span>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    renderComments = () => {
        const { comments } = this.state;

        return comments.map((item: any, index: number) => {
            const commentDt = getDateParts(item.createdOn);
            return (
                <div className="card comment-file mb-3" key={index}>
                    <div className="card-body">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                <div>
                                    <span>({index + 2})</span>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                                <strong>{item.statusName}</strong>
                            </div>
                            {
                                item.comment && <div className="col-md-12 text-justify">
                                    <div dangerouslySetInnerHTML={{ __html: item.comment.replace(/(?:\r\n|\r|\n)/g, '<br>') }} />
                                </div>
                            }
                        </div>
                        <div className="row mt-3">
                            <div className="col-md-6">
                            </div>
                            <div className="col-md-6 text-right">
                                <span className="fs-12">
                                    {item.createdByName}<br />
                                    {item.createdByDesignation}<br />
                                    {`${commentDt.date} ${commentDt.monthName} ${commentDt.year} ${commentDt.hour}:${commentDt.minute}:${commentDt.seconds} ${commentDt.amOrpm}`}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            )
        })
    }

    onAddComment = (model: any) => {
        this.setState({ showLoader: true });
        addComment(model).then(async (res: any) => {
            this.setState({ showLoader: false });
            if (res) {
                if (res.status === CONSTANT.static.apiStatus.success) {
                    this.props.history.push(CONSTANT.component.userLeaveEncashmentList.url);
                } else {
                    alert(res.error);
                }
            }
        });
    }

    onPrint = (e: any) => {
        const mainSection = $('.main-file');
        const commentSection = $('.comment-file');
        let html = mainSection.html();
        for (let i = 0; i < commentSection.length; i++) {
            html += commentSection[i].innerHTML;
        }

        const style = `
        <link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/4.4.1/css/bootstrap.min.css" integrity="sha384-Vkoo8x4CGsO3+Hhxv8T/Q5PaXtkKtu6ug5TOeNV6gBiFeWPGFN9MuhOf23Q9Ifjh" crossorigin="anonymous">
        <style type="text/css">
        body{
            font-size:16px;
        }
        .no-print{visibility: hidden; display:none;}
        .card-body{
            border-bottom: 2px dotted gray;
        }
        
        @page{
            size:A4,
            margin-top: 2cm;
            margin-bottom: 2cm;
            margin-left:6cm;
            margin-right:1.5cm;
        }
        @media print {
            body
            {
                font-size:15.5pt;
            }
            
            .print-btn{
                visibility:hidden;
            }
        }
        </style>
        `;
        const innerHTML = `${style}<button class="print-btn float-right" onclick="window.print()">Print Now</button></div><div class="fluid-container">${html}<br/><button class="print-btn float-right" onclick="window.print()">Print Now</button></div>`;
        let myWindow: any = window.open('', '', 'width=800,height=600');
        myWindow.document.write(innerHTML);
        myWindow.focus();
    }

    toggleAddComment = () => {
        this.setState({ showAddComment: !this.state.showAddComment });
    }
}

export default ComponentName;